import { dataCaretUp } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCaretUp = /*#__PURE__*/createIcon(dataCaretUp)
export default IconCaretUp
